document.addEventListener('DOMContentLoaded', function () {

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (drawer) drawer.setAttribute('data-open', 'true'); });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (drawer) drawer.setAttribute('data-open', 'false'); });
  });

  /* ---------- header shadow + scroll progress on scroll ---------- */
  var header = document.querySelector('.site-header');
  var progress = document.querySelector('[data-scroll-progress]');
  var onScroll = function () {
    if (header) header.style.boxShadow = window.scrollY > 8 ? '0 4px 24px rgba(20,20,40,.12)' : 'none';
    if (progress) {
      var h = document.documentElement;
      var scrolled = h.scrollTop || document.body.scrollTop;
      var height = (h.scrollHeight || document.body.scrollHeight) - h.clientHeight;
      progress.style.width = (height > 0 ? (scrolled / height) * 100 : 0) + '%';
    }
  };
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- gallery thumbnail swap ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = thumb.getAttribute('data-full') || thumb.src;
            main.style.opacity = '1';
          }, 120);
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- 3D tilt on the main product image (app-like depth) ---------- */
  if (!reduceMotion && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.feature__gallery-main').forEach(function (box) {
      var img = box.querySelector('img');
      box.addEventListener('mousemove', function (e) {
        var rect = box.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        box.style.setProperty('--mx', (px * 100) + '%');
        box.style.setProperty('--my', (py * 100) + '%');
        if (img) {
          var rx = (py - 0.5) * -10;
          var ry = (px - 0.5) * 10;
          img.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.03)';
        }
      });
      box.addEventListener('mouseleave', function () {
        if (img) img.style.transform = 'rotateX(0) rotateY(0) scale(1)';
      });
    });
  }

  /* ---------- magnetic buttons ---------- */
  if (!reduceMotion && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.btn--primary, .btn--ghost').forEach(function (btn) {
      btn.setAttribute('data-magnetic', '');
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = (e.clientX - rect.left - rect.width / 2) * 0.25;
        var y = (e.clientY - rect.top - rect.height / 2) * 0.35;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = 'translate(0,0)'; });
    });
  }

  /* ---------- ripple on button click ---------- */
  document.querySelectorAll('.btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var rect = btn.getBoundingClientRect();
      var ripple = document.createElement('span');
      var size = Math.max(rect.width, rect.height);
      ripple.className = 'ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 650);
    });
  });

  /* ---------- quantity steppers (product page) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  });

  /* ---------- confetti burst (celebration on add-to-cart) ---------- */
  function fireConfetti() {
    if (reduceMotion) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.scale(dpr, dpr);
    var colors = ['#FF4324', '#2F5BFF', '#B6FF3C', '#FFB300'];
    var pieces = [];
    for (var i = 0; i < 60; i++) {
      pieces.push({
        x: window.innerWidth / 2,
        y: window.innerHeight * 0.35,
        vx: (Math.random() - 0.5) * 14,
        vy: Math.random() * -10 - 4,
        size: Math.random() * 6 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3
      });
    }
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      pieces.forEach(function (p) {
        p.vy += 0.35;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });
      if (elapsed < 1400) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(frame);
  }

  /* ============================================================
     CART DRAWER — full AJAX cart (open/close, render, qty, remove)
     ============================================================ */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartBody = document.querySelector('[data-cart-items]');
  var cartFooter = document.querySelector('[data-cart-footer]');
  var cartSubtotalEl = document.querySelector('[data-cart-subtotal]');
  var cartCountLabelEl = document.querySelector('[data-cart-drawer-count]');
  var progressFill = document.querySelector('[data-cart-progress-fill]');
  var progressText = document.querySelector('[data-cart-progress-text]');
  var freeShipThreshold = cartDrawer ? parseInt(cartDrawer.getAttribute('data-free-shipping-threshold'), 10) * 100 : 199900;

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return '₹' + amount.toFixed(0);
    }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', 'true');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', 'false');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    });
  }

  function renderCartItem(item) {
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
    var comparePrice = item.original_line_price !== item.final_line_price
      ? '<span class="cart-item__price-compare">' + formatMoney(item.original_line_price) + '</span>' : '';
    var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_200x$1$2') : '';

    return (
      '<div class="cart-item" data-cart-line-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-item__media"><img src="' + img + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
        '<div class="cart-item__info">' +
          '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
          variantLine +
          '<div class="cart-item__price-row">' +
            '<div class="qty-stepper qty-stepper--sm" data-cart-qty data-key="' + item.key + '">' +
              '<button type="button" data-cart-step="-1" aria-label="Decrease quantity">−</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" aria-label="Quantity" data-cart-qty-input data-key="' + item.key + '">' +
              '<button type="button" data-cart-step="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cart-item__price">' + comparePrice + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-item__remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0-1 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 6h12z"/></svg>' +
        '</button>' +
      '</div>'
    );
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;
    updateHeaderCount(cart.item_count);
    if (cartCountLabelEl) cartCountLabelEl.textContent = '(' + cart.item_count + ')';
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);

    if (progressFill && progressText) {
      if (cart.total_price >= freeShipThreshold) {
        progressFill.style.width = '100%';
        progressText.innerHTML = '🎉 You\'ve unlocked <strong>Free Shipping!</strong>';
      } else {
        var remaining = freeShipThreshold - cart.total_price;
        var pct = Math.min(100, (cart.total_price / freeShipThreshold) * 100);
        progressFill.style.width = pct + '%';
        progressText.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for Free Shipping';
      }
    }

    if (!cart.items || cart.items.length === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M6 6 5 2H2"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<button type="button" class="btn btn--primary" data-cart-close>Continue Shopping</button>' +
        '</div>';
      if (cartFooter) cartFooter.style.display = 'none';
      var closeBtn = cartBody.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    } else {
      cartBody.innerHTML = cart.items.map(renderCartItem).join('');
      if (cartFooter) cartFooter.style.display = '';
      bindCartLineEvents();
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function refreshCartDrawer() {
    return fetchCart().then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); })
      .then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function bindCartLineEvents() {
    cartBody.querySelectorAll('[data-cart-qty]').forEach(function (stepper) {
      var key = stepper.getAttribute('data-key');
      var input = stepper.querySelector('[data-cart-qty-input]');
      stepper.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-cart-step'), 10);
          var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          changeCartLine(key, newQty);
        });
      });
      input.addEventListener('change', function () {
        var newQty = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartLine(key, newQty);
      });
    });
    cartBody.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-cart-line-item]');
        if (row) row.style.opacity = '.4';
        changeCartLine(btn.getAttribute('data-key'), 0);
      });
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer();
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });
  var checkoutBtn = document.querySelector('[data-cart-checkout]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  /* ---------- AJAX add to cart (opens drawer with peek detailing) ---------- */
  document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form)))
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              var message = (data && data.description) || (data && data.message) || 'Could not add this item to your cart.';
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () { return refreshCartDrawer(); })
        .then(function () {
          if (submitBtn) { submitBtn.textContent = 'Added ✓'; }
          fireConfetti();
          openCartDrawer();
          setTimeout(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          }, 1600);
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          alert(err && err.message ? err.message : 'Sorry, this item could not be added to your cart. Please try again.');
        });
    });
  });

  /* ---------- Buy Now — add to cart then jump straight to checkout ---------- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = btn.closest('form');
      if (!form) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Redirecting…';

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form)))
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              var message = (data && data.description) || (data && data.message) || 'Could not add this item to your cart.';
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('Buy now failed:', err);
          btn.disabled = false;
          btn.textContent = originalText;
          alert(err && err.message ? err.message : 'Sorry, this item could not be added to your cart. Please try again.');
        });
    });
  });

  /* ---------- swatch buttons (visual only, single-option safe) ---------- */
  document.querySelectorAll('[data-swatch-group]').forEach(function (group) {
    group.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        group.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        swatch.setAttribute('aria-pressed', 'true');
        var hiddenInput = group.parentElement.querySelector('input[type="hidden"][data-variant-id]');
        if (hiddenInput && swatch.getAttribute('data-variant-id')) {
          hiddenInput.value = swatch.getAttribute('data-variant-id');
        }
      });
    });
  });

  /* ---------- cinematic scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-scale');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- animated odometer count-up for spec values ---------- */
  var specDDs = document.querySelectorAll('.spec-row dd');
  if (specDDs.length && 'IntersectionObserver' in window) {
    var specIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        specIo.unobserve(el);
        var text = el.textContent.trim();
        var match = text.match(/^([\d.]+)(.*)$/);
        if (!match || reduceMotion) { return; }
        var target = parseFloat(match[1]);
        var suffix = match[2];
        var decimals = (match[1].split('.')[1] || '').length;
        el.setAttribute('data-counted', 'true');
        var startTs = null;
        var duration = 900;
        function tick(ts) {
          if (!startTs) startTs = ts;
          var p = Math.min(1, (ts - startTs) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    specDDs.forEach(function (el) { specIo.observe(el); });
  }

  /* ---------- floating buy bar (shows once hero buy panel is scrolled past) ---------- */
  var floatBuy = document.querySelector('[data-float-buy]');
  var buyAnchor = document.querySelector('#buy');
  if (floatBuy && buyAnchor && 'IntersectionObserver' in window) {
    var buyIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        floatBuy.setAttribute('data-show', (!entry.isIntersecting && entry.boundingClientRect.top < 0) ? 'true' : 'false');
      });
    }, { threshold: 0 });
    buyIo.observe(buyAnchor);
  }

  /* ---------- gentle parallax on hero media ---------- */
  var parallax = document.querySelector('[data-parallax]');
  if (parallax && !reduceMotion) {
    document.addEventListener('scroll', function () {
      var offset = window.scrollY * 0.15;
      parallax.style.transform = 'translate3d(0,' + offset + 'px,0)';
    }, { passive: true });
  }

  /* ---------- bottom tab bar active state on scroll ---------- */
  var tabLinks = document.querySelectorAll('[data-tab-link]');
  if (tabLinks.length) {
    tabLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        tabLinks.forEach(function (l) { l.classList.remove('is-active'); });
        link.classList.add('is-active');
      });
    });
  }

});
